import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { toast, ToastContainer } from 'react-toastify';
import { api } from '../services'; // Adjust the import path as needed

export const WalletPayment = () => {
  const { register, handleSubmit, formState: { errors } } = useForm();
  const navigate = useNavigate();
  const location = useLocation();
  const key = localStorage.getItem('key');
  const [walletBalance, setWalletBalance] = useState(0);

  const handleBack = () => {
    navigate(-1);
  };

  const fetchData = async () => {
    try {
      const response = await api.get(`Home/GetProfileInfo?SesID=${key}&OID=1`);
      let data = response.data;
      if (typeof data === 'string') {
        try {
          data = JSON.parse(data);
        } catch (error) {
          console.error('Invalid JSON string:', data);
          return;
        }
      }
      // تبدیل مقدار منفی به مثبت
      const balance = data[0]?.Bedehi || 0;
      setWalletBalance(Math.abs(balance)); // استفاده از Math.abs برای مثبت کردن
      return data;
    } catch (error) {
      console.error('Error fetching profile info:', error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const onSubmit = async (data) => {
    const { amount } = data;
    try {
      // فرض بر استفاده از API مشابه برای پرداخت
      const response = await api.post('/request-pay', {
        amount: parseInt(amount), // تبدیل به عدد
      });

      const { paymentURL, authority } = response.data;
      localStorage.setItem('authority', authority);
      localStorage.setItem('wallet_amount', amount); // ذخیره مبلغ برای استفاده بعدی
      toast.success('در حال هدایت به درگاه پرداخت...');
      window.open(paymentURL, '_blank');
    } catch (error) {
      console.error('Error initiating wallet payment:', error);
      toast.error('خطا در شروع پرداخت');
    }
  };

  return (
    <>
      <section className="container maxw mb-5">
        <ToastContainer />
        {/* Navigation Path */}
        <div className="row mb-4 mt-2">
          <div className="col-lg-12 path">
            <ul>
              <li>
                <Link className="text-decoration-none" to="/">
                  صفحه اصلی
                </Link>
                <FontAwesomeIcon icon={faAngleLeft} className="mr-2" />
              </li>
              {location.state?.from && (
                <li>
                  <span style={{ cursor: 'pointer' }} onClick={handleBack} className="text-primary">
                    {location.state.from}
                  </span>
                  <FontAwesomeIcon icon={faAngleLeft} className="mr-2" />
                </li>
              )}
              <li>
                <span>پرداخت کیف پول</span>
              </li>
            </ul>
          </div>
        </div>
        <div className="wallet-payment-card">
          <div className="row gap-3 justify-content-center">
            <div className="col-lg-5 card p-3 shadow rounded-3 mx-2">
              <div className="wallet-payment-body d-flex flex-column align-items-center pt-4">
                <form
                  onSubmit={handleSubmit(onSubmit)}
                  className="wallet-payment-form d-flex flex-column align-items-center w-100"
                >
                  <div className="form-group text-center w-75 pt-5">
                    <p>
                      شما می‌توانید از این اعتبار برای رزرو نوبت‌ها استفاده کنید
                    </p>
                    <h5>اعتبار شما</h5>
                    <h5>{walletBalance.toLocaleString()} ریال</h5>
                    {/* <input
                      type="number"
                      name="amount"
                      id="amount"
                      className={`form-control rounded-input mb-3 ${errors.amount ? 'is-invalid' : ''}`}
                      placeholder="مبلغ (به ریال)"
                      style={{
                        borderRadius: '10px',
                        padding: '10px',
                        fontSize: '16px',
                        textAlign: 'right',
                      }}
                      {...register('amount', {
                        required: 'مبلغ الزامی است',
                        min: {
                          value: 1000,
                          message: 'مبلغ باید حداقل 1000 ریال باشد',
                        },
                      })}
                    />
                    {errors.amount && (
                      <div className="invalid-feedback text-right">
                        {errors.amount.message}
                      </div>
                    )}
                    <button
                      type="submit"
                      name="pay"
                      id="pay"
                      className="btn btn-primary w-100"
                    >
                      پرداخت
                    </button> */}
                  </div>
                </form>
              </div>
            </div>
            <div className="col-lg-5 card p-3 shadow rounded-3 mx-2">
              <img
                src={'/Img/wallet.png'} // تصویر مرتبط با کیف پول
                className="wallet-image w-100 h-100"
                alt="wallet"
                style={{ objectFit: 'cover' }}
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};